"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocxReportTemplateTableColumnPropertyMapping = exports.BatchSettlementDocxTemplateTableColumnProperties = exports.PaymentInKindNoticeDocxTemplateTableColumnProperties = exports.DisbursementNoticeDocxTemplateTableColumnProperties = exports.InvoiceDocxTemplateTableColumnProperties = exports.AssetVerificationDocxTemplateTableColumnProperties = exports.ReceivablesSaleAgreementDocxTemplateTableColumnProperties = exports.FundingRequestDocxTemplateTableColumnProperties = exports.DocxReportTemplatePropertyMapping = exports.BatchSettlementDocxTemplateProperties = exports.PaymentInKindNoticeDocxTemplateProperties = exports.DisbursementNoticeDocxTemplateProperties = exports.InvoiceDocxTemplateProperties = exports.AssetVerificationDocxTemplateProperties = exports.ReceivablesSaleAgreementDocxTemplateProperties = exports.FundingRequestDocxTemplateProperties = exports.UploadDownstreamProcess = exports.UploadDownstreamProcessIterable = exports.reportTemplateType = exports.XlsxReportTemplateType = exports.XlsxReportTemplateTypeIterable = exports.DocxReportTemplateType = exports.DocxReportTemplateTypeIterable = exports.ReportTypeSchema = exports.ReportTypeIterable = exports.DocxTemplate = exports.ReportXlsxTemplate = exports.ReportV2 = void 0;
const zod_1 = require("zod");
// Re-export namespaces as modules
exports.ReportV2 = __importStar(require("./Report/ReportV2"));
exports.ReportXlsxTemplate = __importStar(require("./Report/ReportXlsxTemplate"));
exports.DocxTemplate = __importStar(require("./Report/DocxTemplate"));
// Import for internal usage below
const DocxTemplate = __importStar(require("./Report/DocxTemplate"));
exports.ReportTypeIterable = [
    'placeholderReportType',
    'responseTape',
    'extendedResponseTape',
    'newlyAssignedExtendedResponseTape',
    'rawAssignedLoanTape',
    'cashBalancesFeed',
    'monthlyServicerReport',
    'servicerReport',
    'servicerReportPdf',
    'borrowingBaseCertificate',
    'borrowerSubmittedServicerReport',
    'noticeOfBorrowing',
    'releaseNotice',
    'noticeOfPrepayment',
    'receivablesSaleAgreement',
];
exports.ReportTypeSchema = zod_1.z.enum(exports.ReportTypeIterable);
exports.DocxReportTemplateTypeIterable = [
    'assetVerification',
    'borrowingBaseCertificate',
    'fundingNotice',
    'noticeOfBorrowing',
    'noticeOfPrepayment',
    'releaseNotice',
    'receivablesSaleAgreement',
    'invoice',
    'disbursementNotice',
    'paymentInKindNotice',
    'batchSettlement',
];
exports.DocxReportTemplateType = {
    assetVerification: 'assetVerification',
    borrowingBaseCertificate: 'borrowingBaseCertificate',
    fundingNotice: 'fundingNotice',
    noticeOfBorrowing: 'noticeOfBorrowing',
    noticeOfPrepayment: 'noticeOfPrepayment',
    releaseNotice: 'releaseNotice',
    receivablesSaleAgreement: 'receivablesSaleAgreement',
    invoice: 'invoice',
    disbursementNotice: 'disbursementNotice',
    paymentInKindNotice: 'paymentInKindNotice',
    batchSettlement: 'batchSettlement',
};
exports.XlsxReportTemplateTypeIterable = [
    'borrowingBaseServicerReport',
    'fundingRequestServicerReport',
    'receivableResponseTapePreviewServicerReport',
    'servicerReport',
    'monthlyServicerReport',
];
exports.XlsxReportTemplateType = {
    borrowingBaseServicerReport: 'borrowingBaseServicerReport',
    fundingRequestServicerReport: 'fundingRequestServicerReport',
    receivableResponseTapePreviewServicerReport: 'receivableResponseTapePreviewServicerReport',
    servicerReport: 'servicerReport',
    monthlyServicerReport: 'monthlyServicerReport',
};
exports.reportTemplateType = {
    ...exports.DocxReportTemplateType,
    ...exports.XlsxReportTemplateType,
};
exports.UploadDownstreamProcessIterable = ['financialCovenant'];
exports.UploadDownstreamProcess = {
    FinancialCovenant: 'financialCovenant',
};
exports.FundingRequestDocxTemplateProperties = [
    DocxTemplate.DocxTemplateProperties.borrowingBaseAmount,
    DocxTemplate.DocxTemplateProperties.borrowingBaseReserveAmount,
    DocxTemplate.DocxTemplateProperties.cashReserveAmount,
    DocxTemplate.DocxTemplateProperties.collectionsRecycleAmount,
    DocxTemplate.DocxTemplateProperties.commitmentAmount,
    DocxTemplate.DocxTemplateProperties.drawRequestTotalAmount,
    DocxTemplate.DocxTemplateProperties.remainingCollectionsAmount,
    DocxTemplate.DocxTemplateProperties
        .drawRequestComponentAmountByCapitalProvider,
    DocxTemplate.DocxTemplateProperties.currentPrincipalBalance,
    DocxTemplate.DocxTemplateProperties.totalMaxAdvanceAmount,
    DocxTemplate.DocxTemplateProperties.prepaymentAmount,
    DocxTemplate.DocxTemplateProperties.currentDate,
    DocxTemplate.DocxTemplateProperties.collectionsRecycleTargetFundingDate,
    DocxTemplate.DocxTemplateProperties.drawRequestTargetFundingDate,
    DocxTemplate.DocxTemplateProperties.prepaymentDate,
    DocxTemplate.DocxTemplateProperties.fundingRequestNumber,
    DocxTemplate.DocxTemplateProperties.wiringInstructionsAccountName,
    DocxTemplate.DocxTemplateProperties.wiringInstructionsAccountNumber,
    DocxTemplate.DocxTemplateProperties.wiringInstructionsInstitutionName,
    DocxTemplate.DocxTemplateProperties.wiringInstructionsRoutingNumber,
    DocxTemplate.DocxTemplateProperties.initialFundingRequestNumber,
];
exports.ReceivablesSaleAgreementDocxTemplateProperties = [
    DocxTemplate.DocxTemplateProperties.currentDate,
    DocxTemplate.DocxTemplateProperties.cutoffDate,
    DocxTemplate.DocxTemplateProperties.reportingDate,
    DocxTemplate.DocxTemplateProperties.purchaseDate,
    DocxTemplate.DocxTemplateProperties.newlyAssignedTotalExposure,
];
// DocxTemplateProperties are being deprecated. This is here to adhere to the old types while deprecation is ongoing.
exports.AssetVerificationDocxTemplateProperties = [];
exports.InvoiceDocxTemplateProperties = [];
exports.DisbursementNoticeDocxTemplateProperties = [];
exports.PaymentInKindNoticeDocxTemplateProperties = [];
exports.BatchSettlementDocxTemplateProperties = [];
exports.DocxReportTemplatePropertyMapping = {
    [exports.DocxReportTemplateType.assetVerification]: exports.AssetVerificationDocxTemplateProperties,
    [exports.DocxReportTemplateType.receivablesSaleAgreement]: exports.ReceivablesSaleAgreementDocxTemplateProperties,
    [exports.DocxReportTemplateType.borrowingBaseCertificate]: exports.FundingRequestDocxTemplateProperties,
    [exports.DocxReportTemplateType.noticeOfBorrowing]: exports.FundingRequestDocxTemplateProperties,
    [exports.DocxReportTemplateType.releaseNotice]: exports.FundingRequestDocxTemplateProperties,
    [exports.DocxReportTemplateType.noticeOfPrepayment]: exports.FundingRequestDocxTemplateProperties,
    [exports.DocxReportTemplateType.fundingNotice]: exports.FundingRequestDocxTemplateProperties,
    [exports.DocxReportTemplateType.invoice]: exports.InvoiceDocxTemplateProperties,
    [exports.DocxReportTemplateType.disbursementNotice]: exports.DisbursementNoticeDocxTemplateProperties,
    [exports.DocxReportTemplateType.paymentInKindNotice]: exports.PaymentInKindNoticeDocxTemplateProperties,
    [exports.DocxReportTemplateType.batchSettlement]: exports.BatchSettlementDocxTemplateProperties,
};
exports.FundingRequestDocxTemplateTableColumnProperties = [];
exports.ReceivablesSaleAgreementDocxTemplateTableColumnProperties = [
    DocxTemplate.DocxTemplateTableColumnProperties.finleyReceivableId,
    DocxTemplate.DocxTemplateTableColumnProperties.externalReceivableId,
    DocxTemplate.DocxTemplateTableColumnProperties.purchasePrice,
    DocxTemplate.DocxTemplateTableColumnProperties.exposure,
    DocxTemplate.DocxTemplateTableColumnProperties.purchasePercentageRate,
    DocxTemplate.DocxTemplateTableColumnProperties.agreementCreationDate,
];
// DocxTemplateProperties are being deprecated. This is here to adhere to the old types while deprecation is ongoing.
exports.AssetVerificationDocxTemplateTableColumnProperties = [];
exports.InvoiceDocxTemplateTableColumnProperties = [];
exports.DisbursementNoticeDocxTemplateTableColumnProperties = [];
exports.PaymentInKindNoticeDocxTemplateTableColumnProperties = [];
exports.BatchSettlementDocxTemplateTableColumnProperties = [];
exports.DocxReportTemplateTableColumnPropertyMapping = {
    [exports.DocxReportTemplateType.assetVerification]: exports.AssetVerificationDocxTemplateTableColumnProperties,
    [exports.DocxReportTemplateType.receivablesSaleAgreement]: exports.ReceivablesSaleAgreementDocxTemplateTableColumnProperties,
    [exports.DocxReportTemplateType.borrowingBaseCertificate]: exports.FundingRequestDocxTemplateTableColumnProperties,
    [exports.DocxReportTemplateType.noticeOfBorrowing]: exports.FundingRequestDocxTemplateTableColumnProperties,
    [exports.DocxReportTemplateType.releaseNotice]: exports.FundingRequestDocxTemplateTableColumnProperties,
    [exports.DocxReportTemplateType.noticeOfPrepayment]: exports.FundingRequestDocxTemplateTableColumnProperties,
    [exports.DocxReportTemplateType.fundingNotice]: exports.FundingRequestDocxTemplateTableColumnProperties,
    [exports.DocxReportTemplateType.invoice]: exports.InvoiceDocxTemplateTableColumnProperties,
    [exports.DocxReportTemplateType.disbursementNotice]: exports.DisbursementNoticeDocxTemplateTableColumnProperties,
    [exports.DocxReportTemplateType.paymentInKindNotice]: exports.PaymentInKindNoticeDocxTemplateTableColumnProperties,
    [exports.DocxReportTemplateType.batchSettlement]: exports.BatchSettlementDocxTemplateTableColumnProperties,
};
//# sourceMappingURL=Report.js.map